import { toJS } from "mobx"
import FormStore from "../../Configs/Store/forms"

const CALCULATE_RETURN_URL = window.location.href.includes("testing") ? process.env.REACT_APP_CALCULATE_RETURN_PREPROD_URL : process.env.REACT_APP_CALCULATE_RETURN_URL

const QuoteAPI = async (FormStore, CalcForm, QuoteForm, FundForm, ExtraForm, lifeCoverFlag = false, salesOffline) => {
  // ExtraForm = SWP/AWT

  // var SalesChannel = salesOffline ? 0 : 7
  var SalesChannel = salesOffline ? 10 : 7
  var SalesMode = salesOffline ? "OF" : "ON"

  // var CalcFormValues = await CalcForm.getFieldsValue()
  var QuoteFormValues = await QuoteForm.getFieldsValue()
  var FundFormValues = await FundForm.getFieldsValue()
  var ExtraFormValues = await ExtraForm.getFieldsValue()

  var ModalPremium = QuoteFormValues["youInvest"] + ""
  ModalPremium = ModalPremium.includes(",") ? ModalPremium.replace(/,/g, "") : ModalPremium
  ModalPremium = Number(ModalPremium)
  var ModeOfPayment = QuoteFormValues["every"]
  var AnnualPremium = ModeOfPayment === "Monthly" ? ModalPremium * 12 : ModeOfPayment === "Half-Yearly" ? ModalPremium * 2 : ModalPremium
  AnnualPremium = Number(AnnualPremium)

  // var IP_ADD = window.ipAddress
  var IP_ADD = ""

  var TermNoYear = QuoteFormValues["policyTerm"]
  var Term = Number(TermNoYear)
  // Term = Term > 30 ? 99 - Number(FormStore.calc_age) : Term
  var PremiumPaymentTerm = QuoteFormValues["paymentFreq"] === "Regular" ? Term : QuoteFormValues["payFor"]
  var SAMultiple = PremiumPaymentTerm === 1 && FormStore.calc_age > 45 ? 1.25 : 10
  var DeathBenefit = lifeCoverFlag ? FormStore.quote_lifeCover : SAMultiple * AnnualPremium

  var AnnualSalary = FormStore.calc_annual

  var FundsTab = FormStore.quote_fundsTab // As per, Age, Assets, Portfolio
  var PortfolioStrategy = FundsTab === 0 ? "Fixed" : FundsTab === 1 ? "LifeCycle 2" : FundsTab === 2 ? "Target Asset Allocation" : "TriggerFund"
  var PremiumPaymentOption = QuoteFormValues["paymentFreq"] + " Pay"
  PremiumPaymentOption = Term > 30 ? "Limited Whole life" : PremiumPaymentOption

  ////////////////////////////////////// FUNDS ///////////////////////////////////////////

  var localFunds = window.UserInput["funds"] // For LocalStorage API call Accurate Data //
  // console.info("FundFormValues :", localFunds, FundFormValues)
  var isFundFormAvail = Object.entries(FundFormValues).length > 0
  var bypassLocalStorage = true
  var syncFlag = false

  var CMGF = 0
  var OPPF = 0
  var BLUF = 0
  var VGTH = 0
  var MCBF = 0
  var INCF = 0
  var MMAF = 0
  var MAIF = 0
  var AABF = 0
  var VEEF = 0
  var SOBF = 0
  var F50F = 0
  var COPF = 0
  var BADF = 0
  var SNEF = 0
  var MCF = 0
  var HBGW = 0
  var CMTF = 0
  var MNDF = 0
  var MSDF = 0
  var MCMQ = 0
  var SCMQ = 0
  var ICMF = 0


  if (isFundFormAvail) {
    var zeroFlag = false
    var reqKey = "fundAllocationInput_Tab_" + FormStore.quote_fundsTab + "_"

    var reqValues = await Object.keys(FundFormValues)
      .filter(function (k) {
        return k.indexOf(reqKey) == 0
      })
      .reduce(function (newData, k) {
        if (typeof FundFormValues[k] === "number") {
          newData[k] = FundFormValues[k]
        } else if (typeof FundFormValues[k] === "string") {
          newData[k] = Number(FundFormValues[k].replace("%", ""))
        } else {
          newData[k] = 0
        }

        if (newData[k] > 0) {
          zeroFlag = true
        }
        console.info(`FundFormValues newData_${k} :`, newData[k])
        return newData
      }, {})

    if (!zeroFlag) {
      console.info("All Funds Are Not 0")
    }

    BLUF = undefinedFlag(reqValues[reqKey + "BLUF"], BLUF)
    F50F = undefinedFlag(reqValues[reqKey + "F50F"], F50F)
    CMGF = undefinedFlag(reqValues[reqKey + "CMGF"], CMGF)
    OPPF = undefinedFlag(reqValues[reqKey + "OPPF"], OPPF)
    VGTH = undefinedFlag(reqValues[reqKey + "5GTH"], VGTH)
    MCBF = undefinedFlag(reqValues[reqKey + "MCBF"], MCBF)
    INCF = undefinedFlag(reqValues[reqKey + "INCF"], INCF)
    MMAF = undefinedFlag(reqValues[reqKey + "MMAF"], MMAF)
    MAIF = undefinedFlag(reqValues[reqKey + "MAIF"], MAIF)
    AABF = undefinedFlag(reqValues[reqKey + "AABF"], AABF)
    VEEF = undefinedFlag(reqValues[reqKey + "VEEF"], VEEF)
    SOBF = undefinedFlag(reqValues[reqKey + "SOBF"], SOBF)
    COPF = undefinedFlag(reqValues[reqKey + "COPF"], COPF)
    BADF = undefinedFlag(reqValues[reqKey + "BADF"], BADF)
    SNEF = undefinedFlag(reqValues[reqKey + "SNEF"], SNEF)
    MCF = undefinedFlag(reqValues[reqKey + "MCF"], MCF)
    HBGW = undefinedFlag(reqValues[reqKey + "HBGW"], HBGW)
    MNDF = undefinedFlag(reqValues[reqKey + "MNDF"], MNDF)
    MSDF = undefinedFlag(reqValues[reqKey + "MSDF"], MSDF)
    MCMQ = undefinedFlag(reqValues[reqKey + "MCMQ"], MCMQ)
    SCMQ = undefinedFlag(reqValues[reqKey + "SCMQ"], SCMQ)
    ICMF = undefinedFlag(reqValues[reqKey + "ICMF"], ICMF)

    if (!zeroFlag && FormStore.quote_investStrat === "Aggressive") {
      // If Not Prefilling (First Time Landing) Then Force  Mid Cap Fund (Earlier : Maximer Fund) // Else Sync From UserInput
      MCF = 100
    } else {
      syncFlag = true
    }
    console.info("Required Values QuoteAPI Fund :", reqValues)
  }

  console.info("FundFormValues Zero Sync InvestStrat :", zeroFlag, syncFlag, FormStore.quote_investStrat)
  if (!isFundFormAvail || syncFlag) {
    CMGF = 0
    OPPF = 0
    BLUF = 0
    VGTH = 0
    MCBF = 0
    INCF = 0
    MMAF = 0
    MAIF = 0
    AABF = 0
    VEEF = 0
    SOBF = 0
    F50F = 0
    COPF = 0
    BADF = 0
    SNEF = 0
    MCF = 0
    HBGW = 0
    MNDF = 0
    MSDF = 0
    MCMQ = 0
    SCMQ = 0
    ICMF = 0
    var selectedInvest = await toJS(FormStore.quote_investFundSelected)
    console.info("FundFormValues AltElse", selectedInvest)
    if (selectedInvest.length > 0) {
      for (var i = 0; i < selectedInvest.length; i++) {
        // [selectedInvest[i]['LAfundCode']] = 100 / selectedInvest.length
        var ITEM = selectedInvest[i]
        var KEY = ITEM["LAfundCode"]
        KEY = KEY === "5GTH" ? "VGTH" : KEY
        var ALLOC = typeof ITEM["fundAllocation"] === "string" ? Number(ITEM["fundAllocation"].replace("%", "")) : typeof ITEM["fundAllocation"] === "number" ? ITEM["fundAllocation"] : 0
        eval(KEY + " = " + ALLOC)
        console.info("FundFormValues ALLOC :", ALLOC)
      }
    } else {
      // TODO: Recursive Call QuoteAPI & updateFundExpandData from QuoteInvest.js via useEffect
    }
  }
  var UserInput_Funds = {
    multi_cap_growth: CMGF / 100,
    bluechip: BLUF / 100,
    opportunities: OPPF / 100,
    maximiser_v: VGTH / 100,
    multi_cap_balanced: MCBF / 100,
    income: INCF / 100,
    money_market: MMAF / 100,
    maximise_india: MAIF / 100,
    active_asset_allocation_balanced: AABF / 100,
    value_enhancer: VEEF / 100,
    secure_opportunities: SOBF / 100,
    focus_50: F50F / 100,
    india_growth: COPF / 100,
    balanced_advantage: BADF / 100,
    sustainable_equity: SNEF / 100,
    mid_cap: MCF / 100,
    mid_cap_hybrid: HBGW / 100,
    multicap_50_25_25_index_fund: MNDF / 100,
    midSmallcap_400_index_fund: MSDF / 100,
    midSmallcap_400_momentum_quality_fund: MCMQ / 100,
    india_consumption_fund: ICMF / 100
  }

  window.UserInput["funds"] = UserInput_Funds
  console.info("FundFormValues Updated :", UserInput_Funds)

  ////////////////////////////////////// FUNDS ///////////////////////////////////////////

  ///////////////////////////////////// SWP //////////////////////////////////////////////

  var localCollectSWP = window.UserInput["swp"]
  var swpYears = localCollectSWP["year"]
  var swpPercen = localCollectSWP["payout_per"]

  var SWP_PayoutMode = undefinedFlag(ExtraFormValues["paymentMode"], localCollectSWP["SWP_mode"])
  var SWP_PayoutDate = undefinedFlag(ExtraFormValues["paymentDate"], localCollectSWP["SWP_payDate"])

  var DoItYourSelfYear1 = undefinedFlag(ExtraFormValues["payoutYear_0"], swpYears[0]) // CHeck Value if Undefiend. If Yes then use AltValue value as 0 here
  DoItYourSelfYear1 = RandomFlag("NA", DoItYourSelfYear1, 0) // Check Value if equals to flag value . NA here. If true ise AltValue as 0
  var DoItYourSelfYear2 = undefinedFlag(ExtraFormValues["payoutYear_1"], swpYears[1])
  DoItYourSelfYear2 = RandomFlag("NA", DoItYourSelfYear2, 0)
  var DoItYourSelfYear3 = undefinedFlag(ExtraFormValues["payoutYear_2"], swpYears[2])
  DoItYourSelfYear3 = RandomFlag("NA", DoItYourSelfYear3, 0)
  var DoItYourSelfYear4 = undefinedFlag(ExtraFormValues["payoutYear_3"], swpYears[3])
  DoItYourSelfYear4 = RandomFlag("NA", DoItYourSelfYear4, 0)
  var DoItYourSelfYear5 = undefinedFlag(ExtraFormValues["payoutYear_4"], swpYears[4])
  DoItYourSelfYear5 = RandomFlag("NA", DoItYourSelfYear5, 0)

  var DoItYourSelfPayOut1 = undefinedFlag(ExtraFormValues["payoutPercentage_0"], swpPercen[0])
  DoItYourSelfPayOut1 = RandomFlag("NA", DoItYourSelfPayOut1, 0)
  var DoItYourSelfPayOut2 = undefinedFlag(ExtraFormValues["payoutPercentage_1"], swpPercen[1])
  DoItYourSelfPayOut2 = RandomFlag("NA", DoItYourSelfPayOut2, 0)
  var DoItYourSelfPayOut3 = undefinedFlag(ExtraFormValues["payoutPercentage_2"], swpPercen[2])
  DoItYourSelfPayOut3 = RandomFlag("NA", DoItYourSelfPayOut3, 0)
  var DoItYourSelfPayOut4 = undefinedFlag(ExtraFormValues["payoutPercentage_3"], swpPercen[3])
  DoItYourSelfPayOut4 = RandomFlag("NA", DoItYourSelfPayOut4, 0)
  var DoItYourSelfPayOut5 = undefinedFlag(ExtraFormValues["payoutPercentage_4"], swpPercen[4])
  DoItYourSelfPayOut5 = RandomFlag("NA", DoItYourSelfPayOut5, 0)

  var SWP_Flag = FormStore.quote_cardOneRadio === "Y" ? "true" : "false"
  if (DoItYourSelfYear1 === 0 && DoItYourSelfPayOut1 === 0) {
    SWP_Flag = localCollectSWP["SWP"] === "Yes" ? "true" : "false"
  }
  ///////////////////////////////////// SWP //////////////////////////////////////////////

  ///////////////////////////////////// ATS //////////////////////////////////////////////

  var ATPTransferDate = ExtraFormValues["dot"] ? ExtraFormValues["dot"] : FormStore.quote_dot
  var TargetFundATP = ExtraFormValues["to"] ? ExtraFormValues["to"] : FormStore.quote_to
  var SourceFundATP = ExtraFormValues["from"] ? ExtraFormValues["from"] : FormStore.quote_from
  SourceFundATP = window.UserInput["ats"]["fundFrm"] === "" ? SourceFundATP : window.UserInput["ats"]["fundFrm"]
  SourceFundATP = typeof SourceFundATP === "string" ? SourceFundATP : ""
  var ATPAmount = undefinedFlag(ExtraFormValues["transferAmount"], FormStore.quote_transferAmount + "")
  ATPAmount = ATPAmount.replace(/,/g, "").replace(/\D+/g, "")
  ATPAmount = typeof ATPAmount === "string" && ATPAmount !== "" ? Number(ATPAmount) : ""
  var ATPFlag = "false"
  var QuoteCardTwoFlag = FormStore.quote_cardTwoRadio === "Y"
  console.info("FundFormValues Card2", ATPAmount, ATPTransferDate, TargetFundATP, ExtraFormValues["from"], SourceFundATP, UserInput_Funds["income"], UserInput_Funds["money_market"])
  if (ATPAmount && ATPTransferDate && TargetFundATP && SourceFundATP && (UserInput_Funds["income"] > 0 || UserInput_Funds["money_market"] > 0)) {
    ATPFlag = QuoteCardTwoFlag ? "true" : "false"
  } else {
    if (QuoteCardTwoFlag) {
      FormStore.setCardTwoRadio("N")
      UserInput("ats", "No", "ats", "")
    }
  }

  console.info("Quote Values :", ExtraFormValues)
  ///////////////////////////////////// ATS //////////////////////////////////////////////

  window.UserInput["saMultiple"] = SAMultiple
  window.UserInput["ppt"] = PremiumPaymentTerm
  window.UserInput["term"] = Term
  window.UserInput["whole_life"] = Term > 30 ? true : false

  var body = {
    FirstName: "",
    LastName: "",
    DateOfBirth: FormStore.calc_dob.split("/").reverse().join("-"), // "2000-02-02",
    Gender: FormStore.calc_gender,
    MaritalStatus: "",
    PolicyholderFName: "",
    PolicyholderLName: "",
    PolicyholderDOB: "",
    PolicyholderGender: "",
    isPolicyholder: "false",
    Staff: "0",
    AgeProof: "",
    ServiceTaxNotApplicable: "0",
    AreaCode: "",
    ProductDetails: {
      Product: {
        ProductType: "ULIP",
        ProductName: "Signature",
        ProductCode: "UW3",
        ModeOfPayment: ModeOfPayment,
        ModalPremium: ModalPremium,
        AnnualPremium: AnnualPremium,
        Term: Term,
        Term1: "0",
        DeathBenefit: DeathBenefit,
        PremiumPaymentTerm: PremiumPaymentTerm,
        PortfolioStrategy: PortfolioStrategy,
        MaturityAmount: "",
        InvestmentProfile: "",
        RGF: "0",
        AnnuityOption: "",
        PensionFrequency: "",
        AnnuityYears: "0",
        SpouseAge: "0",
        ChildAge: "0",
        ChildMaturityAge: "0",
        HospitalCarePlan: "",
        UnitOfCoverage: "0",
        SpouseOpted: "0",
        SpouseName: "",
        SpouseDOB: "",
        Option: "0",
        PolicyCommencementDate: "",
        Tobacco: "0",
        HomeLoan: "0",
        SalesChannel: SalesChannel,
        RGFTerm: "0",
        Objective: "",
        UserGroup: "",
        LoanTenure: "0",
        LoanAmount: "0",
        AnnuityPayoutFrequency: "",
        CashBenefitMode: "0",
        ModeOfIncome: "0",
        SAMultiple: SAMultiple,
        PremiumPaymentOption: PremiumPaymentOption,
        Option_HP: "",
        FundAllocations: [
          {
            Fund: [
              {
                Name: "Multi Cap Growth Fund",
                Value: CMGF,
              },
              {
                Name: "Opportunities Fund",
                Value: OPPF,
              },
              {
                Name: "Bluechip Fund",
                Value: BLUF,
              },
              {
                Name: "Maximiser Fund V",
                Value: VGTH,
              },
              {
                Name: "Multi Cap Balanced Fund",
                Value: MCBF,
              },
              {
                Name: "Income Fund",
                Value: INCF,
              },
              {
                Name: "Money Market Fund",
                Value: MMAF,
              },
              {
                Name: "Maximise India Fund",
                Value: MAIF,
              },
              {
                Name: "Active Asset Allocation Balanced Fund",
                Value: AABF,
              },
              {
                Name: "Value Enhancer Fund",
                Value: VEEF,
              },
              {
                Name: "Secure Opportunities Fund",
                Value: SOBF,
              },
              {
                Name: "Focus 50 Fund",
                Value: F50F,
              },
              {
                Name: "India Growth Fund",
                Value: COPF,
              },
              {
                Name: "Balanced Advantage Fund",
                Value: BADF,
              },
              {
                Name: "Sustainable Equity Fund",
                Value: SNEF,
              },
              {
                Name: "Mid Cap Fund",
                Value: MCF,
              },
              {
                Name: "Mid Cap Hybrid Growth Fund",
                Value: HBGW,
              },
              {
                Name: "Multicap 50 25 25 Index Fund",
                Value: MNDF,
              },
              {
                Name: "MidSmall Cap 400 Index Fund",
                Value: MSDF,
              },
              {
                Name: "MidSmallCap 400 Momentum Quality 100 Index Fund",
                Value: MCMQ,
              },
              {
                Name: "Smallcap250 Momentum Quality 100 Index Fund",
                Value: SCMQ,
              },
              {
                Name: "India Consumption Fund",
                Value: ICMF,
              }
            ],
          },
        ],
        ChildDetails: "",
        RiderDetails: {
          Rider: {
            Name: "ADBR",
            SA: "0",
            Term: "0",
          },
        },
        LifeTime: "",
        ADHB: "0",
        StoryCode: "",
        AnnuityAmount: "",
        LoanType: "",
        SelectedOption: "",
        PlanType: "",
        LifeCoverOption: "",
        CIBenefit: "0",
        TotalPremium_ADB: "",
        CoverageOption: "",
        DeathBenefitOption: "",
        MasterCode: "",
        TierType: "",
        PFMSelection: "",
        InvestmentAmount: "0",
        InvestmentOption: "",
        AnnualSalary: AnnualSalary,
        NPSInvestmentPer: "0",
        IsAnnuityCalculation: "",
        PolicyEndDate: "",
        Funded: "",
        BranchCode: "00DM",
        SourceCode: "WEB0",
        RIB: "false",
        SpouseDeathBenefit: "0",
        SpouseCIBenefit: "0",
        SpouseLifeCoverOption: "",
        SpouseADHB: "0",
        SpouseDeathBenefitOption: "",
        SpouseLumpsumPercentage: "0",
        P_LAN: "",
        JointLifePolicyFor: "",
        TobaccoJL: "0",
        IsCalculateXRT: "",
        Heart_XRT: "0",
        Cancer_XRT: "0",
        HeartJL_XRT: "0",
        CancerJL_XRT: "0",
        LumpsumPercentage: "0",
        IPSDiscount: "false",
        SanctionAmount: "0",
        LoanSanctionDate: "",
        DisbursalDate: "",
        DisbursalAmount: "0",
        Occupation: "",
        UnderConstruction: "false",
        PropertyType: "",
        PremiumAffordability: "0",
        FTDate: "",
        OccupationSpouse: "",
        NumberOfLanguages: "1",
        Language1: "ENG",
        Language2: "",
        IsSelected: "",
        Mode: SalesMode,
        SWP: SWP_Flag,
        Goal: Term > 30 ? "Retirement" : "Do It Yourself",
        PayoutMode: SWP_PayoutMode.toLowerCase(),
        PayoutDate: SWP_PayoutDate,
        RetireYearlyINC: Term > 30 ? DoItYourSelfPayOut1 : 0,
        RetirementAge: FormStore.quote_cardOneRadio === "Y" ? (Term > 30 ? DoItYourSelfYear1 : "0") : "0", // Greater than 30 = whole life here
        DoItYourSelfYear1: SWP_Flag ? DoItYourSelfYear1 : 0,
        DoItYourSelfYear2: SWP_Flag ? DoItYourSelfYear2 : 0,
        DoItYourSelfYear3: SWP_Flag ? DoItYourSelfYear3 : 0,
        DoItYourSelfYear4: SWP_Flag ? DoItYourSelfYear4 : 0,
        DoItYourSelfYear5: SWP_Flag ? DoItYourSelfYear5 : 0,
        DoItYourSelfPayOut1: SWP_Flag ? DoItYourSelfPayOut1 : 0,
        DoItYourSelfPayOut2: SWP_Flag ? DoItYourSelfPayOut2 : 0,
        DoItYourSelfPayOut3: SWP_Flag ? DoItYourSelfPayOut3 : 0,
        DoItYourSelfPayOut4: SWP_Flag ? DoItYourSelfPayOut4 : 0,
        DoItYourSelfPayOut5: SWP_Flag ? DoItYourSelfPayOut5 : 0,
        QROPS: "",
        AdditionalBenefits: "",
        FamilyBenefit: "false",
        LoyaltyBenefit: "false",
        DeathBenefitHeart: "0",
        DeathBenefitCancer: "0",
        DeathBenefitHeartJL: "0",
        DeathBenefitCancerJL: "0",
        IPAddress: IP_ADD,
        BenefitOption: "0",
        SpousePPT: "0",
        LumpSumAmount: "0",
        NPSFlag: "false",
        BenefitIllustration: "",
        ISWelcome: "",
        ATPTransferDate: ATPTransferDate,
        SourceFundATP: SourceFundATP,
        Priority: "",
        CashStartYear: "",
        CostofMarriage: "",
        TargetFundATP: TargetFundATP,
        ATPAmount: ATPAmount,
        ATPFlag: ATPFlag,
        IncomeStartAge: "",
        IncomeEndAge: "",
        PayoutTerm: "",
        SpouseGender: "",
        PayoutOption: "",
        isKeralaCess: "false",
        PayoutMonth: 4,
      },
    },
  }

  window.userInputRequestJSON = body
  var logTMp = body["ProductDetails"]["Product"]
  console.info("Body Values :", logTMp.SWP, logTMp.Goal, logTMp.PayoutDate, logTMp.PayoutMode)

  const reqParams = {
    method: "POST",
    body: JSON.stringify(body),
    headers: { "Content-Type": "application/json" },
  }

  const response = await fetch(CALCULATE_RETURN_URL, reqParams)
    .then((res) => res.json())
    .then((result) => {
      console.info("Calculate Return :", result)
      return result
    })
    .catch((error) => {
      console.info("Error :", error)
      return error
    })

  return response
}

// const advanceReplace = (value, replaceKey, replaceBy) => {
//   return Number(value.replace(replaceKey, replaceBy))
// }

const undefinedFlag = (value, altValue) => {
  return value === undefined ? altValue : value
}

const RandomFlag = (flag, value, altValue) => {
  return value === flag ? altValue : value
}

const UserInput = (key, value, subKey = "", extraFlag) => {
  if (subKey !== "") {
    window.UserInput[key][subKey] = value
  } else {
    window.UserInput[key] = value
  }
  console.log("set user input")
  FormStore.setUserInput(window.UserInput)
}

export { QuoteAPI, UserInput }
